(function () {
  'use strict';
  if (window.self !== window.top) return;
  if (window.__massaGommeAnalyticsLoaded) return;
  window.__massaGommeAnalyticsLoaded = true;

  var ENDPOINT = 'https://www.mastergomme.com/massagomme-analytics.php';
  var FLEET_NAMES = {
    1:'Transit Quintos Blue',2:'Renault Master L1 Rovato',3:'Volkswagen Crafter 3 VA',
    4:'Fiat Ducato L3 TO',5:'Ford Transit Blue',6:'Peugeot Boxer Blue',
    7:'Citroen Jumper telonato',8:'Volkswagen Crafter 1',9:'Ford Transit B A',
    10:'Fiat Ducato L1',12:'Renault Traffic Quintos',
    13:'Mercedes Vito',14:'Hyundai H350',15:'Fiat Ducato cassonato',
    16:'Volkswagen Crafter 2',17:'Ford Custom',18:'Renault Master Euro 5',19:'Ford Transit'
  };
  var viewTimers = new WeakMap();
  var viewStates = new WeakMap();
  var observed = new WeakSet();
  var viewedVehicles = Object.create(null);
  var lastSelectedVehicle = 0;
  var lastSelectedVehicleAt = 0;
  var sid = '';
  var tabId = '';
  var started = false;
  var handlersInstalled = false;
  var heartbeatTimer = 0;
  var lastWhatsAppEvent = { key: '', at: 0 };
  var SELECTION_MAX_AGE = 15 * 60 * 1000;

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID().replace(/-/g, '');
    }
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var bytes = new Uint8Array(24);
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    }
    return String(Date.now()) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

  function safeStorage(storage, key, fallback) {
    try {
      var current = storage.getItem(key);
      if (current) return current;
      storage.setItem(key, fallback);
      return fallback;
    } catch (error) { return fallback; }
  }

  function sessionId() {
    var key = 'massa_analytics_session_v1';
    var stampKey = 'massa_analytics_session_at_v1';
    var now = Date.now();
    try {
      var existing = window.localStorage.getItem(key);
      var stamp = Number(window.localStorage.getItem(stampKey) || 0);
      if (!existing || !stamp || now - stamp > 30 * 60 * 1000) {
        existing = randomId();
        window.localStorage.setItem(key, existing);
      }
      window.localStorage.setItem(stampKey, String(now));
      return existing;
    } catch (error) { return randomId(); }
  }

  function privacyState() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        if (typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed !== 'function') {
          return 'pending';
        }
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true ? 'allowed' : 'denied';
      }
    } catch (error) { return 'pending'; }
    return 'absent';
  }

  function analyticsAllowed() {
    var state = privacyState();
    return state === 'allowed' || state === 'absent';
  }

  function imageForNumber(number) {
    return 'https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-' +
      String(number).padStart(2, '0') + '.jpg';
  }

  function cleanNumber(value) {
    var number = Number(value || 0);
    return number >= 1 && number <= 19 && number !== 11 ? number : 0;
  }

  function numberFromText(value) {
    var text = String(value || '');
    var imageMatch = text.match(/flotta-(\d{2})\.jpg/i);
    if (imageMatch) return cleanNumber(imageMatch[1]);
    var numberMatch = text.match(/(?:(?:furgone|mezzo)(?:[\s:#-]*n(?:umero)?\.?)?|n(?:umero)?\.?)[\s:#-]*(1[0-9]|[1-9])\b/i);
    return numberMatch ? cleanNumber(numberMatch[1]) : 0;
  }

  function recentSelectedVehicle() {
    if (!lastSelectedVehicle || !lastSelectedVehicleAt ||
        Date.now() - lastSelectedVehicleAt > SELECTION_MAX_AGE) {
      lastSelectedVehicle = 0;
      lastSelectedVehicleAt = 0;
      if (started) {
        try {
          window.sessionStorage.removeItem('massa_selected_vehicle_v1');
          window.sessionStorage.removeItem('massa_selected_vehicle_at_v1');
        } catch (error) {}
      }
    }
    return lastSelectedVehicle;
  }

  function restoreSelectedVehicle() {
    try {
      lastSelectedVehicle = cleanNumber(window.sessionStorage.getItem('massa_selected_vehicle_v1'));
      lastSelectedVehicleAt = Number(window.sessionStorage.getItem('massa_selected_vehicle_at_v1') || 0);
    } catch (error) {
      lastSelectedVehicle = 0;
      lastSelectedVehicleAt = 0;
    }
    recentSelectedVehicle();
  }

  function vehicleFromElement(element) {
    if (!element || !element.closest) return { number: recentSelectedVehicle(), node: null };
    var node = element.closest('[data-vehicle-number],.vehicle-option,.alternative-select,.fleet .card,.centinato,.gallery-item,.vehicle-preview');
    var number = 0;
    if (node) {
      number = cleanNumber(node.getAttribute('data-vehicle-number'));
      if (!number) {
        var img = node.querySelector('img');
        number = numberFromText((img && (img.currentSrc || img.src)) || '');
      }
      if (!number) number = numberFromText(node.textContent || '');
    }
    if (!number && element.href) {
      try { number = numberFromText(decodeURIComponent(String(element.href))); } catch (error) {}
    }
    if (!number) number = recentSelectedVehicle();
    return { number: number, node: node };
  }

  function dates() {
    var pickup = document.getElementById('pickup-date');
    var returning = document.getElementById('return-date');
    return {
      pickup_date: pickup && /^\d{4}-\d{2}-\d{2}$/.test(pickup.value) ? pickup.value : '',
      return_date: returning && /^\d{4}-\d{2}-\d{2}$/.test(returning.value) ? returning.value : ''
    };
  }

  function send(eventName, extra) {
    if (!started || !sid || !tabId || !analyticsAllowed()) return;
    var vehicle = cleanNumber(extra && extra.vehicle);
    var payload = Object.assign({
      event: eventName,
      event_id: randomId(),
      sid: sid,
      tab_id: tabId,
      path: window.location.pathname || '/',
      title: document.title || 'Massa Gomme',
      vehicle: vehicle,
      vehicle_label: vehicle ? FLEET_NAMES[vehicle] : '',
      image: vehicle ? imageForNumber(vehicle) : ''
    }, dates(), extra || {});
    var body = JSON.stringify(payload);
    var delivered = false;
    try {
      if (navigator.sendBeacon) {
        delivered = navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      }
    } catch (error) {}
    if (!delivered && window.fetch) {
      fetch(ENDPOINT, {
        method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body
      }).catch(function () {});
    }
  }

  function markVehicleSelection(number) {
    number = cleanNumber(number);
    if (!number) return;
    lastSelectedVehicle = number;
    lastSelectedVehicleAt = Date.now();
    try {
      window.sessionStorage.setItem('massa_selected_vehicle_v1', String(number));
      window.sessionStorage.setItem('massa_selected_vehicle_at_v1', String(lastSelectedVehicleAt));
    } catch (error) {}
    send('vehicle_select', { vehicle: number });
  }

  var observer = null;

  function createFleetObserver() {
    if (observer || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var target = entry.target;
        var info = vehicleFromElement(target);
        var visible = Boolean(entry.isIntersecting && entry.intersectionRatio >= 0.45);
        viewStates.set(target, visible);

        if (!info.number || viewedVehicles[info.number]) {
          if (viewTimers.has(target)) {
            window.clearTimeout(viewTimers.get(target));
            viewTimers.delete(target);
          }
          if (info.number && viewedVehicles[info.number]) observer.unobserve(target);
          return;
        }

        if (visible) {
          if (!viewTimers.has(target)) {
            (function (node, number) {
              viewTimers.set(node, window.setTimeout(function () {
                viewTimers.delete(node);
                var current = vehicleFromElement(node);
                if (viewedVehicles[number]) {
                  observer.unobserve(node);
                  return;
                }
                if (!viewStates.get(node) || !document.documentElement.contains(node) ||
                    document.visibilityState === 'hidden' || current.number !== number) return;
                viewedVehicles[number] = true;
                send('vehicle_card_view', { vehicle: number });
                observer.unobserve(node);
              }, 900));
            }(target, info.number));
          }
        } else if (viewTimers.has(target)) {
          window.clearTimeout(viewTimers.get(target));
          viewTimers.delete(target);
        }
      });
    }, { threshold: [0.45, 0.7] });
  }

  function observeFleet(root) {
    if (!observer) return;
    var nodes = (root || document).querySelectorAll('[data-vehicle-number],.vehicle-option,.fleet .card,.centinato,.gallery-item');
    Array.prototype.forEach.call(nodes, function (node) {
      if (observed.has(node)) return;
      var info = vehicleFromElement(node);
      if (!info.number) return;
      observed.add(node);
      observer.observe(node);
    });
  }

  function whatsappHref(value) {
    return String((value && value.href) || value || '');
  }

  function isWhatsAppLink(value) {
    var href = whatsappHref(value);
    return /(?:^whatsapp:|(?:^|\/\/)(?:wa\.me|(?:api|web|www)\.whatsapp\.com)(?:[\/:?#]|$))/i.test(href);
  }

  function numberFromWhatsAppHref(href) {
    try { return numberFromText(decodeURIComponent(String(href || '').replace(/\+/g, ' '))); } catch (error) { return 0; }
  }

  function trackWhatsApp(value, sourceElement) {
    var href = whatsappHref(value);
    if (!isWhatsAppLink(href)) return false;

    var vehicle = numberFromWhatsAppHref(href);
    var generalCta = sourceElement && sourceElement.closest && sourceElement.closest('.js-wa-general');
    if (generalCta) {
      vehicle = 0;
    } else if (!vehicle && sourceElement) {
      vehicle = vehicleFromElement(sourceElement).number;
    } else if (!vehicle) {
      vehicle = recentSelectedVehicle();
    }

    var now = Date.now();
    if (now - lastWhatsAppEvent.at < 1500) return true;
    lastWhatsAppEvent = { key: String(vehicle) + '|' + href, at: now };
    send('whatsapp_click', { vehicle: vehicle });
    return true;
  }

  function installWindowOpenFallback() {
    if (typeof window.open !== 'function' || window.open.__massaGommeWhatsAppFallback) return;
    var originalOpen = window.open;
    var wrappedOpen = function () {
      if (isWhatsAppLink(arguments[0])) trackWhatsApp(arguments[0], null);
      return originalOpen.apply(this, arguments);
    };
    wrappedOpen.__massaGommeWhatsAppFallback = true;
    window.open = wrappedOpen;
  }

  function installEventHandlers() {
    if (handlersInstalled) return;
    handlersInstalled = true;

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      var link = target.closest('a[href]');
      if (link && isWhatsAppLink(link)) {
        trackWhatsApp(link, link);
        return;
      }
      var option = target.closest('.vehicle-option,.alternative-select,[data-vehicle-number],.fleet .card,.gallery-item');
      if (option) {
        var info = vehicleFromElement(option);
        if (info.number) markVehicleSelection(info.number);
      }
      var button = target.closest('button,input[type="submit"],a');
      var label = String((button && (button.textContent || button.value || button.id || button.className)) || '');
      if (button && /(?:calcola|preventivo|cerca|verifica disponibil|km-calc-btn)/i.test(label)) {
        var searchInfo = vehicleFromElement(button);
        send('rental_search', { vehicle: searchInfo.number || recentSelectedVehicle() });
      }
    }, true);

    document.addEventListener('change', function (event) {
      var element = event.target;
      if (!element) return;
      if (element.type === 'date') {
        var idName = String((element.id || '') + ' ' + (element.name || ''));
        if (/(?:pickup|ritiro|start|inizio)/i.test(idName) && /^\d{4}-\d{2}-\d{2}$/.test(element.value)) {
          send('pickup_date_select', { vehicle: recentSelectedVehicle(), pickup_date: element.value });
        }
      }
      if (element.matches && element.matches('select')) {
        var selected = element.options && element.selectedIndex >= 0 ? element.options[element.selectedIndex] : null;
        var number = numberFromText((selected && selected.textContent) || element.value || '');
        if (number) markVehicleSelection(number);
      }
    }, true);

    window.addEventListener('pagehide', function () {
      send('presence_hide', { vehicle: recentSelectedVehicle() });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') send('presence_hide', { vehicle: recentSelectedVehicle() });
      else send('heartbeat', { vehicle: recentSelectedVehicle() });
    });
    installWindowOpenFallback();
  }

  var domStartQueued = false;
  var pendingAbsentFallback = false;

  function start(allowAbsentFallback) {
    if (started) return;
    if (document.readyState === 'loading') {
      pendingAbsentFallback = pendingAbsentFallback || Boolean(allowAbsentFallback);
      if (!domStartQueued) {
        domStartQueued = true;
        document.addEventListener('DOMContentLoaded', function () {
          domStartQueued = false;
          start(pendingAbsentFallback);
        }, { once: true });
      }
      return;
    }

    var state = privacyState();
    if (state !== 'allowed' && !(allowAbsentFallback && state === 'absent')) return;

    started = true;
    sid = sessionId();
    tabId = safeStorage(window.sessionStorage, 'massa_analytics_tab_v1', randomId());
    restoreSelectedVehicle();
    createFleetObserver();
    installEventHandlers();
    observeFleet(document);
    send('page_view', { vehicle: recentSelectedVehicle() });
    send('heartbeat', { vehicle: recentSelectedVehicle() });
    heartbeatTimer = window.setInterval(function () {
      if (document.visibilityState !== 'hidden') send('heartbeat', { vehicle: recentSelectedVehicle() });
    }, 45000);
    if ('MutationObserver' in window) {
      new MutationObserver(function (changes) {
        changes.forEach(function (change) {
          Array.prototype.forEach.call(change.addedNodes || [], function (node) {
            if (node.nodeType === 1) observeFleet(node.matches && node.matches('[data-vehicle-number],.vehicle-option,.fleet .card,.centinato,.gallery-item') ? node.parentNode : node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function probePrivacy(attempt) {
    if (started) return;
    var state = privacyState();
    if (state === 'allowed') {
      start(false);
    } else if (state === 'absent') {
      if (attempt < 8) window.setTimeout(function () { probePrivacy(attempt + 1); }, 250);
      else start(true);
    }
  }

  document.addEventListener('visitorConsentCollected', function () {
    var attempt = 0;
    function startAfterConsent() {
      if (started) return;
      var state = privacyState();
      if (state === 'allowed') start(false);
      else if ((state === 'pending' || state === 'absent') && attempt < 6) {
        attempt += 1;
        window.setTimeout(startAfterConsent, 100 * attempt);
      }
    }
    startAfterConsent();
  });

  probePrivacy(0);
}());
